import { Link } from 'react-router-dom';
import { useDarkMode } from '@/hooks/useDarkMode';
import DarkModeToggle from '@/components/common/DarkModeToggle';

interface PublicLayoutProps {
  children: React.ReactNode;
}

export default function PublicLayout({ children }: PublicLayoutProps) {
  const { isDarkMode } = useDarkMode();

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 dark:from-gray-900 dark:to-gray-800 flex flex-col">
      {/* Simple header with logo */}
      <header className="bg-white dark:bg-gray-800 border-b border-gray-200 dark:border-gray-700">
        <div className="max-w-7xl mx-auto px-2 sm:px-6 lg:px-8 py-4 flex items-center justify-between">
          <Link to="/" className="cursor-pointer inline-block">
            <img
              src={isDarkMode ? "/logo_light.png" : "/logo.png"}
              alt="Sven Bolz Trading Academy"
              className="h-10"
            />
          </Link>
          <DarkModeToggle />
        </div>
      </header>

      {/* Main content */}
      <main className="flex-grow py-8 px-2 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto">
          {children}
        </div>
      </main>
    </div>
  );
}
